import React from 'react';
import { useDispatch } from 'react-redux';

import labster from 'app/shared/utils/labster';
import { LabsterDashboard } from '@zg-rentals/particles-js-labster-ui';

const ExperimentsPage = () => {
    const dispatch = useDispatch();

    return (
        <LabsterDashboard
            dispatch={dispatch}
            labster={labster}
        />
    );
};

export default ExperimentsPage;
